import { useStore } from 'zustand';
import { createStore } from 'zustand/vanilla';
import { useAppStoreApi } from '../../../store/appStore';

const initialState = {
    moduleName: null,
    gridData: [],
    searchControls: [],
    isListChanged: true,
    filterControlValues: {},
    hoverFilterValues: null,
    filterPayload: null,
};


const createApproverStore = () => createStore((set) => ({
    // State
    ...initialState,

    // Setters
    setModuleName: (name) => set({ moduleName: name }),
    setGridData: (data) => set({ gridData: data }),
    setSearchControls: (data) => set({ searchControls: data }),
    setIsListChanged: (data) => set({ isListChanged: data }),
    setFilterControlValues: (data) => set({ filterControlValues: data }),
    setHoverFilterValues: (data) => set({ hoverFilterValues: data }),
    setFilterPayload: (data) => set({ filterPayload: data }),

    // Reset store
    destroy: () => set({ ...initialState }),
    // Initialize with optional values
    initialize: (values = {}) => set({ ...initialState, ...values }),
}));

const stores = new WeakMap();
export const useApproverStore = () => {
    const tabStore = useAppStoreApi();
    if (!stores.has(tabStore)) {
        stores.set(tabStore, createApproverStore());
    }
    return useStore(stores.get(tabStore));
};
